import 'uni-pages';
import Vue from 'vue'
import Page from './pagesA/opinionList/opinionList.vue'
createPage(Page)